"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SovereignCloudEnvironment = void 0;
exports.getEntraEndpoint = getEntraEndpoint;
exports.getDefaultAuthorityUrl = getDefaultAuthorityUrl;
exports.getTenantedAuthorityUrl = getTenantedAuthorityUrl;
exports.getSovereignCloudEnvironment = getSovereignCloudEnvironment;
exports.isSovereignHigh = isSovereignHigh;
const featureFlags_1 = require("./featureFlags");
var SovereignCloudEnvironment;
(function (SovereignCloudEnvironment) {
    SovereignCloudEnvironment["Public"] = "Public";
    SovereignCloudEnvironment["GCCM"] = "GCC M";
    SovereignCloudEnvironment["GCCH"] = "GCC H";
    SovereignCloudEnvironment["DOD"] = "DoD";
})(SovereignCloudEnvironment || (exports.SovereignCloudEnvironment = SovereignCloudEnvironment = {}));
function getEntraEndpoint() {
    const sovereignCloudEnvironment = featureFlags_1.featureFlagManager.getStringValue(featureFlags_1.FeatureFlags.SovereignCloudEnvironment);
    if (sovereignCloudEnvironment === SovereignCloudEnvironment.GCCH ||
        sovereignCloudEnvironment === SovereignCloudEnvironment.DOD) {
        return "https://login.microsoftonline.us";
    }
    return "https://login.microsoftonline.com";
}
function getDefaultAuthorityUrl() {
    return `${getEntraEndpoint()}/common`;
}
function getTenantedAuthorityUrl(tenantId) {
    return `${getEntraEndpoint()}/${tenantId}`;
}
function getSovereignCloudEnvironment() {
    const sovereignCloudEnvironment = featureFlags_1.featureFlagManager.getStringValue(featureFlags_1.FeatureFlags.SovereignCloudEnvironment);
    if (sovereignCloudEnvironment &&
        Object.values(SovereignCloudEnvironment).includes(sovereignCloudEnvironment)) {
        return sovereignCloudEnvironment;
    }
    return SovereignCloudEnvironment.Public;
}
function isSovereignHigh() {
    const env = getSovereignCloudEnvironment();
    return env === SovereignCloudEnvironment.GCCH || env === SovereignCloudEnvironment.DOD;
}
//# sourceMappingURL=accountUtils.js.map